// 剪貼簿共用 util — navigator.clipboard 只在 secure context（HTTPS/localhost）存在；
// 後台常用 http://<IP>:8082 直開 → 必須 fallback execCommand('copy')（insecure context 仍可用）。
// 回傳 true/false，呼叫端依結果顯示「已複製」，不要無條件顯示。
export async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
        try { await navigator.clipboard.writeText(text); return true; } catch { /* fall through */ }
    }
    try {
        const ta = document.createElement('textarea');
        ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.focus(); ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
    } catch { return false; }
}
